<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app,
html,
body {
  width: 100%;
}
* {
  margin: 0;
  padding: 0;
  outline: none;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
#app {
  margin: 0px auto;
  height: 100%;
}
.hand {
  cursor: pointer;
}
/* // 多余省略号 */
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* #app .sidebar-container .is-active > .el-submenu__title{
  color: #1D60E3;
} */
.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
.el-dialog .el-button {
  width: 100px;
  height: 40px;
}
.el-dialog .el-dialog__header {
  padding: 0 !important;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  color: rgb(40, 45, 55);
}
.el-dialog__footer {
  padding: 0;
  padding-bottom: 40px;
}
.dialog-footer {
  padding: 0;
  padding-left: 336px;
  padding-right: 336px;
  display: flex;
  justify-content: space-between;
}
.el-dialog .el-button--primary {
  background: rgb(29, 96, 227);
  border-color: rgb(29, 96, 227);
}
.el-dialog .el-button--primary:hover {
  background: rgb(29, 96, 227);
  border-color: rgb(29, 96, 227);
}
.el-pager li.active {
  background: rgb(236, 241, 251);
  color: rgb(29, 96, 227);
}
.el-pager li:hover {
  color: rgb(29, 96, 227);
}
.header-title {
  width: 100%;
  height: 60px;
  background: rgb(246, 246, 246);
}
.el-dialog .el-button--default {
  background: rgb(238, 238, 238);
}
.el-dialog .el-textarea .el-textarea__inner {
  height: 123px;
  min-height: 123px;
}
.el-dialog .el-dialog__body {
  padding: 32px 44px 0;
  box-sizing: border-box;
}
.el-dialog .el-form-item__label {
  font-size: 16px;
  font-weight: 400;
  color: rgb(40, 45, 55);
}
.dialog-footer p {
  text-align: center;
  height: 68px;
  line-height: 68px;
  text-align: center;
  color: rgb(29, 96, 227);
  font-size: 20px;
}
.el-menu .el-menu-item:hover {
  outline: 0 !important;
  color: rgb(29, 96, 227) !important;
  background: linear-gradient(270deg, #f2f7fc 0%, #fefefe 100%) !important;
}
.el-menu .el-menu-item.is-active {
  color: rgb(29, 96, 227) !important;
  background: #f8fbff !important;
  border-left: 4px solid #1d60e3 !important;
  box-sizing: border-box !important;
}
.el-menu .el-menu-item {
  border-left: 4px solid #fff !important;
  box-sizing: border-box !important;
}
.el-submenu .el-submenu__title:hover {
  color: rgb(29, 96, 227) !important;
  background: linear-gradient(270deg, #f2f7fc 0%, #fefefe 100%) !important;
}
table{
  width: 100%;
   border-collapse:collapse;
   word-break: break-all;
}
.el-table .el-table__body .el-table__cell {
  padding: 10px 0;
}
.el-table--border {
  border: none;
}
.card table tr th {
  border: 1px solid #e2e2e2;
  height: 50px;
  text-align: center;
  background: #f9f9f9;
  color: #666666;
  font-size: 14px;
  text-align: left;
  padding: 5px 20px;
  box-sizing: border-box;
}

.card table tr td {
  border: 1px solid #e2e2e2;
  height: 50px;
  text-align: center;
  background: #fff;
  color: #333333;
  font-size: 14px;
  text-align: left;
  padding: 5px 20px;
  box-sizing: border-box;
}
.el-menu{
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue